<h1 mat-dialog-title class="w-100"><i class="fa-solid fa-book"></i> Wprowadź adresy firmowe</h1>
<mat-dialog-content class="mat-typography" class="w-100">
	<mat-form-field class="w-100">
		<input matInput type="text" placeholder="Adres" [(ngModel)]="addressData.address" />
	</mat-form-field>
	<mat-form-field class="w-100">
		<input matInput type="text" placeholder="Kod pocztowy" [(ngModel)]="addressData.zipCode" />
	</mat-form-field>
	<div class="w-100">
		<ng-select placeholder="Miasto" [(ngModel)]="addressData.location.id">
			@for (location of service.enterpriseData.locations; track location.id) {
				<ng-option [value]="location.id">
					{{ location.name }}
					<small>({{ location.parentLocation?.name }})</small>
				</ng-option>
			}
		</ng-select>
	</div>
	<mat-form-field class="w-100">
		<mat-select placeholder="Typ" [(ngModel)]="addressData.kind">
			@for (item of service.enterpriseData.addressKind; track item.id) {
				<mat-option [value]="item.id"> {{ item.kind }}</mat-option>
			}
		</mat-select>
	</mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" mat-dialog-close>Anuluj</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial (click)="editAddress()">
		Dodaj adres
	</button>
</mat-dialog-actions>
